import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { APP_INITIALIZER, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { CustomTranslateLoaderService } from './app/core/services/translate/custom-translate-loader.service';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CookiesServiceService } from './app/core/services/cookies/cookies-service.service';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { validateSesionInterceptor } from './app/core/interceptors/validate-sesion.interceptor';

import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeEs,'es');

export function appInitializerFactory(translate: TranslateService, cookiesService: CookiesServiceService) {
  return () => {
    cookiesService.openCookiesTerms();
    translate.setDefaultLang(translate.getBrowserLang() ?? 'es');
    return translate.use(translate.getBrowserLang() ?? 'es').toPromise();
  };
}

bootstrapApplication(AppComponent, {
  providers: [
    {provide: LOCALE_ID, useValue: 'es'},
    provideHttpClient( withInterceptors([authInterceptor,validateSesionInterceptor])),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: CustomTranslateLoaderService,
          deps: [HttpClient],
        }
      }),
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, CookiesServiceService],
      multi: true,
    },
    provideRouter(routes),
    provideAnimations()
  ]
})
  .catch((err) => console.error(err));
